import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import CommentCard from './CommentCard';
import dataModel from '../../../models/DataModel';
import { completion_criteria_root } from '../../../dao/CompletionCriteriaDAO';
import DataSource from '../../../dao/DataSource/DataSource';
import './TaskCompletionStepComments.scss';
import Textarea from '../../Textarea';

// TODO: this component is duplicated
export class TaskCompletionStepComments extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
      commentText: '',
      comments: [],
      showKeyboard: true,
      sending: false,
      clickCount: 0,
    };
    this.sortComments = this.sortComments.bind(this);
  }

  handleCSRetrieval(completionStep, action, acData, fetchedData){
    this.setState({ completionStep });
    const sortedComments = this.sortComments(completionStep.comments);
    this.setState({ comments: sortedComments });
  }

  componentDidMount() {
    const { completionStep } = this.props;
    if (completionStep){
      this.csDataSource = new DataSource('CompletionCriterion', completionStep.id, completion_criteria_root, this.handleCSRetrieval);
      this.csDataSource.get();
    }
    const sortedComments = this.sortComments(completionStep.comments);
    this.setState({ comments: sortedComments });
  }

  componentWillUnmount() {
    if (this.csDataSource) {
      this.csDataSource.release();
      this.csDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    const { completionStep } = this.props;
    if (completionStep != prevProps.completionStep) {
      if (this.csDataSource) {
        this.csDataSource.release();
      }
      this.csDataSource = new DataSource('CompletionCriterion', completionStep.id, completion_criteria_root, this.handleCSRetrieval);
      this.csDataSource.get();
    }
    if (prevProps.task != this.props.task) {
      
    }
    else {
      if (!prevProps.task || (this.props.task && this.props.task.completion_citeria != prevProps.task.completion_citeria)) {
        this.setState({ toggleRender: !this.state.toggleRender });
      }
    }
  }

  handleElementAttached(element,e) {
  
    if (!this.element && element && e==null && this.state.showKeyboard) {
      this.commentInput = element;
      this.commentInput.focus(); 
    }  
    else if(e!=null && !this.element && element && !this.state.showKeyboard){
      this.commentInput = element;
      this.commentInput.blur();   
    }
  }

  sortComments(comments) {
    if (comments) {
      return comments.sort((c1, c2) => {
        return c1.created_at < c2.created_at
          ? 1
          : c1.created_at > c2.created_at ? -1 : 0;
      });
    }
  }

  renderComments() {
    const { comments } = this.state;
    return comments.map(comment => {
      return <CommentCard comment={comment} key={comment.id } />;
    });
  }
  handleOnButtonClick(){
    this.state.send=true;
    this.state.sending=true;
    this.handleSendComment();  
  }
  async handleSendComment() {
    const { completionStep } = this.state;
    const { comments, commentText } = this.state;
    this.setState({ sending: true });
    this.state.sending=true;
    this.state.clickCount++;
   
    if (this.state.sending && this.element) {
      this.element.blur();
    }
    if (completionStep && commentText) {
      if (this.props.type == 'REJECTED') {
        this.setState({ commentText: '' });
        if (this.props.commentSent) {
          this.props.commentSent(commentText);
        }
      }
      else {
        const comment = {
          id: dataModel.commentsDAO.commentID,
          body: commentText,
          caption: this.props.type,
          commentable_type: 'CompletionCriterion',
          commentable_id: completionStep.id,
          user_id: this.props.currentUser.id,
        };
        await dataModel.commentsDAO.createComment(comment, false, null, { recordDescriptor: { comments: {} } }).then((createdComment) => {
          const commentObject = createdComment.comment || createdComment;
          if(createdComment){
            this.setState({ sending: true,clickCount: 0 });
          }
          if (this.props.commentSent) {
            this.props.commentSent(commentObject.body);
          }
          comments.unshift(commentObject);
          this.setState({ commentText: '', comments });
          if (this.element) {
            this.element.focus();
          }
        }).catch((error) => {
          // TODO
        });
      }
    }
  }

  handleCommentCancel() {
  }

  handleKeyDown(e) {
    // if (e.keyCode == 13 || e.keyCode == 40) {
    //   e.preventDefault();
    //   this.handleSendComment();
    //   document.activeElement.blur()
    // } else 
    if (e.keyCode == 27) {
      this.handleCommentCancel();
    }
    else  if (e.keyCode == 13 || e.keyCode == 40) {
      this.state.showKeyboard=false;
      this.handleElementAttached(e.target,e);
    }
  }

  handleCommentChange(e) {
    if(e.target.value.trim()!=''){
      this.setState({ commentText: e.target.value });
    }
    else{
      this.setState({ commentText: '' });
    }
  }

  handleSetElement(element) {
    if (!this.element && element) {
      this.element = element;
    }
  }
 
  render() {
    const { completionStep } = this.state;
    if (!completionStep) {
      return null;
    }
    let sendButton = (
      <div className="send-button disabled">
        <div className="send-text disabled">SEND</div>
      </div>
    );
    if (this.state.commentText && this.state.commentText!='') {
      if(this.state.sending && this.state.clickCount>0){
        sendButton = (
          <div className="send-button disabled">
            <div className="send-text disabled">SEND</div>
          </div>
        );
      }else{
        sendButton = (
          <div className={'send-button'} 
          onClick={this.handleSendComment}>
            <div className="send-text">SEND</div>
          </div>
        );
      }
      
    }

    const displayComments = this.renderComments();
    return (
      <div
        className={
          'task-completion-step-comments-mobile ' +
          (this.props.fromPopup ? 'from-popup' : '')
        }
        id={this.props.id}
        onClick={this.handleCommentCancel}
        onTouchStart={this.handleCommentCancel}
      >
        <div className="comment-list">
          <div
            className={
              'comment-title ' +
              (this.props.fromPopup ? 'from-popup ' : '') +
              (displayComments.length == 0 ? 'empty' : '')
            }
          >
            Comments
          </div>
          {displayComments.length > 0 && (
            <div className="comments-mobile">{displayComments}</div>
          )}
        </div>
        <div className="task-comment-input">
          <Textarea
            id={'comment-' + completionStep.id}
            className="text-input-mobile"
            rows={3}
            ref={(e) => {this.handleElementAttached(e,null);}}
            placeholder={
              this.props.placeholder
                ? this.props.placeholder
                : 'Leave comment here.'
            }
            onChange={this.handleCommentChange}
            value={this.state.commentText}
            onKeyDown={this.handleKeyDown}
            dataId={completionStep.id}
            type="send"
            style={{ resize: 'none' }}
          />
          {/* {!this.props.mobileBridge.isMobile && sendButton} */}
          {sendButton}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
    mobileBridge: dataModel.mobileBridge,
  };
};

export default connect(mapStateToProps)(
  TaskCompletionStepComments
);



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/TaskCompletionStepComments/index.js